module.exports = "<search-filter-2 clearFilter></search-filter-2>\r\n<search-categories></search-categories>\r\n<information></information>"